import { z } from "zod";

import { IconsSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

import { EcotrapDetailsSchema } from "@/_pages/ecotrap/model/schemas";
import {
  BackgroundMediaSchema,
  TrailSchema,
} from "@/_pages/single-trail/model/schemas";

/** Сингл-тайп "Карта" (api::map-page) — только заголовок страницы */
export const MapPageInfoSchema = z.object({
  title: z.string().min(1),
});

export const MapPageInfoDtoSchema = z.object({
  data: MapPageInfoSchema,
});

export const PageDtoSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  seo: z.any(),
  rulesSection: z.any(),
  titleWithIcon: z.any(),
  // mapImage — зимняя схема трасс, summerMapImage — карта экотроп
  mapImage: StrapiMediaSchema,
  summerMapImage: StrapiMediaSchema.optional().nullable(),
});

export const StationServiceSchema = z.object({
  id: z.number().int().positive(),
  title: z.string().min(1),
  icon: z.object({
    id: z.number().int().positive(),
    name: IconsSchema,
  }),
});

export const StationSchema = z.object({
  id: z.number().int().positive(),
  uid: z.string().min(1),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  gallery: z.array(BackgroundMediaSchema).min(0).optional(),
  height: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
  services: z.array(StationServiceSchema),
  coordinates: z.string(),
});

export const TrailsDtoSchema = z.array(TrailSchema);

export const StationsDtoSchema = z.array(StationSchema);

// Схема экотропы для карты: заголовок и статус нужны списку точек,
// details и галерея — карточке, которая открывается по клику на схеме
export const MapEcotrapSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  slug: z.string().min(1).optional().nullable(),
  // Поле называется trailStatus, а не status: в Strapi 5 status занят самим
  // документом (draft/published) и своё поле с таким именем ломает сохранение.
  // Старое написание оставлено, пока переименование не доехало до всех стендов
  trailStatus: z.enum(["close", "open"]).optional().nullable(),
  status: z.enum(["open", "closed", "close"]).optional().nullable(),
  details: EcotrapDetailsSchema.partial().optional().nullable(),
  gallery: z.array(StrapiMediaSchema).optional().nullable(),
});

export const MapEcotrapsDtoSchema = z.array(MapEcotrapSchema);
